function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

export function buildDefaultCompanyConfig(globalConfig, company) {
  const aliases = company?.aliases || [];
  return {
    aliases: [...aliases],
    urls: [...(company?.urls || [])],
    keywords: clone(globalConfig?.keyword_weights || {}),
    templates: clone(globalConfig?.query_templates || {}),
    severity: clone(globalConfig?.severity_rules || {}),
  };
}

export function getCompanySettings(companyName, globalConfig, companyMeta) {
  const company = (globalConfig?.companies || []).find(
    c => (c.name || c) === companyName,
  ) || companyMeta;
  return buildDefaultCompanyConfig(globalConfig, company);
}

export function resetCompanySettings(companyName) {
  return companyName;
}

export function saveCompanySettings(companyName, settings) {
  return {
    aliases: settings.aliases,
    urls: settings.urls || [],
    keywords: settings.keywords,
    templates: settings.templates,
    severity: settings.severity,
    updatedAt: new Date().toISOString(),
  };
}

export function addCustomCompany(name, globalCompanies = []) {
  const trimmed = name.trim();
  if (!trimmed) return null;
  const exists = globalCompanies.some(c => (c.name || c).toLowerCase() === trimmed.toLowerCase());
  return { name: trimmed, aliases: [], custom: !exists };
}
